var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDatabaseOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.25C2.685 0.25 0 1.5925 0 3.25V10.75C0 12.4075 2.6925 13.75 6 13.75C9.3075 13.75 12 12.4075 12 10.75V3.25C12 1.5925 9.315 0.25 6 0.25ZM10.5 10.75C10.5 11.125 8.9025 12.25 6 12.25C3.0975 12.25 1.5 11.125 1.5 10.75V9.0775C2.7075 9.6625 4.29 10 6 10C7.71 10 9.2925 9.6625 10.5 9.0775V10.75ZM10.5 7.3375C9.525 8.05 7.815 8.5 6 8.5C4.185 8.5 2.475 8.05 1.5 7.3375V5.23C2.6025 5.8525 4.2075 6.25 6 6.25C7.7925 6.25 9.3975 5.8525 10.5 5.23V7.3375ZM6 4.75C3.0975 4.75 1.5 3.625 1.5 3.25C1.5 2.875 3.0975 1.75 6 1.75C8.9025 1.75 10.5 2.875 10.5 3.25C10.5 3.625 8.9025 4.75 6 4.75Z",
    fill: "#6C757D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseOutline);
export default __webpack_public_path__ + "static/media/DatabaseOutline.7a526658.svg";
export { ForwardRef as ReactComponent };